export const MoneyInModel = {
    money_in_id: 0,
    description: "",
    user_id: 0,
    amount: 0,
    insert_date: "",
    ref_month: 0,
    ref_year: 0
}